export const excelStyles = {
  managerClientCellStyle: {
    fontSize: 9.5,
  },
  projectCellStyle: {
    fontSize: 9.5,
  },
  employeeCellStyle: {
    horizontalAlign: "left",
  },
  publicHolidayCellStyle: {
    backgroundColor: "ffc0cb",
  },
  weekendCell: {
    backgroundColor: "d5d5d5",
  },
  normalCell: {
    backgroundColor: "ffffff",
  },
};
